import React from "react";
import {
  TextArea,
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";
import { BaseModal } from "../../../../../atoms/base-modal";

type Props = {
  isOpen: boolean;
  onClose: () => void;
  applicationIds: string[];
  onChangeApplicationIds: (applicationIds: string[]) => void;
  onExecute: () => void;
  errorMessage: string | null;
};

export const ExportModal: React.FC<Props> = ({
  isOpen,
  onClose,
  applicationIds,
  onChangeApplicationIds,
  onExecute,
  errorMessage,
}) => {
  const handleChangeApplicationIds = React.useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const applicationIds = e.target.value.split("\n").map((id) => id.trim());

      onChangeApplicationIds(applicationIds);
    },
    [onChangeApplicationIds],
  );

  return (
    <BaseModal isActive={isOpen} title="手動で連携を実行" onClose={onClose}>
      <section className="modal-card-body">
        <TextArea
          shouldDisplayError={!!errorMessage}
          errorMessages={errorMessage ? [errorMessage] : undefined}
          required
          description={`申請 id を一行ずつ入力してください。\n一度の実行で最大1000件までの申請 id を指定できます。`}
          placeholder={`例:\n1234567890123456789\n1234567890123456789`}
          label="申請 id"
          value={applicationIds.join("\n")}
          onChange={handleChangeApplicationIds}
        />
      </section>
      <footer
        className="modal-card-foot"
        style={{ justifyContent: "flex-end" }}
      >
        <SecondaryButton onClick={onClose} text="キャンセル" />
        <PrimaryButton
          onClick={onExecute}
          disabled={applicationIds.length === 0}
          text="実行"
        />
      </footer>
    </BaseModal>
  );
};
